const NAMESPACE = 'DUCKS/STATIONS';

export default NAMESPACE;
